<template>
  <div v-if="!store.state.isWorkflowDisabled" class="d-flex" @click.stop>
    <v-tooltip location="bottom">
      <template v-slot:activator="{ props }">
        <v-icon v-bind="props" size="16" color="grey" class="cursor-pointer" @click="openEntityDialog = true">
          mdi-pencil
        </v-icon>
      </template>
      Edit entity
    </v-tooltip>
    <edit-entity-dialog
      :entity="entity"
      :refreshKey="refreshKey"
      :modelValue="openEntityDialog"
      @update:modelValue="(val) => openEntityDialog = val"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
import EditEntityDialog from '@/components/EditEntityDialog.vue'

const { entity, refreshKey } = defineProps({ entity: Object, refreshKey: Number })

const store = useStore()
const openEntityDialog = ref(false)
</script>
